import React from 'react'
import styled from 'styled-components'
import Footer from './components/footer/footer'
import Navbar from './components/navbar/navbar'
import { useAdobeFonts } from 'react-adobe-fonts'
import { device } from '../../config/theme/breakpoints'
import { CloseOutline } from '@styled-icons/evaicons-outline'
import logo from '../../assets/img/logo.png'
import { pathRoutes } from '../routes/paths'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'
import ButtonTC from '../../components/button-tc/button-tc'
import SelectTC from '../../components/select-tc/select-tc'
import banderaPeru from '../../assets/img/bandera_peru.png'
import { ArrowIosForward } from '@styled-icons/evaicons-solid'

const LayoutContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  position: relative;

  * {
    box-sizing: border-box;
    font-family: aller, sans-serif;
    scroll-behavior: smooth;

    > p, a {
      line-height: 26px;
      font-size: 12px;
      font-weight: 100;
      
      @media ${device.laptop}{
        font-size: 14px;
      }

      @media ${device.laptop}{
        font-size: 16px;
      }
    }

    > h1 {
      font-size: 32px;
      font-weight: bold;
      
      @media ${device.tablet}{
        font-size: 36px;
      }

      @media ${device.laptop}{
        font-size: 40px;
      }
    }

    > h2 {
      font-size: 22px;
      
      @media ${device.tablet}{
        font-size: 26px;
      }

      @media ${device.laptop}{
        font-size: 30px;
      }
    }

    > h3 {
      font-size: 16px;
      
      @media ${device.tablet}{
        font-size: 18px;
      }

      @media ${device.laptop}{
        font-size: 20px;
      }
    }

    > h4 {
      font-size: 14px;
      
      @media ${device.tablet}{
        font-size: 16px;
      }

      @media ${device.laptop}{
        font-size: 18px;
      }
    }

    .react-datepicker{
      border-radius: 15px;
      background: white;
      border-radius: 50px 50px 15px 15px;
    }

    .react-datepicker__header {
      background: ${p => p.theme.palette.primary.main};
      border-radius: 20px;
      margin-top: -1px;
      box-shadow: 0 2px 20px 2px #818181ad;

      * {
        color: white !important;
      }
    }
    
    .react-datepicker__month {
      background: white;
    }

    .react-datepicker-wrapper {
      width: 100%;
      text-align: start;
    }
    .react-datepicker__tab-loop {
      min-width: 0px;
      width: 0px;
    }

    .react-datepicker__triangle {
      transform: translate3d(30px, 0px, 0px) !important;
    }
  }
`
const ContainerMenuMobile = styled.div<{ statusMenu: boolean }>`
  position: fixed;
  top: 0;
  transition: .3s;
  width: 100%;
  transform: ${p => p.statusMenu ? 'translateX(0%)' : 'translateX(-100%)'};
  background: #0000008f;
  height: 100%;
  z-index: 12;
`
const ContainerList = styled.div<{ statusMenu: boolean }>`
  position: absolute;
  top: 0;
  transition: .5s;
  width: 80%;
  transform: ${p => p.statusMenu ? 'translateX(0%)' : 'translateX(-80%)'};
  background: white;
  height: 100%;
  z-index: 3;
  padding: 20px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const ContainerRoutes = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`
const ContainerTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 5px;
  width: 100%;
  align-items: flex-start

  > a {
    padding-left: 30px;
    text-align: center;
  }
`
const TextTitle = styled(NavLink)<{ active: boolean }>`
  color: ${p => p.active ? p.theme.palette.text.black : p.theme.palette.text.gray};
  font-weight: ${props => props.active ? 'bold' : 'normal'} !important;
  border-left: 2px solid ${p => p.active ? p.theme.palette.primary.main : 'white'};
  text-decoration: none;
  padding: 10px 14px;
  margin: 0;
`
const ContainerBottomOption = styled.div``
const DividerTextTitle = styled.div`
  height: 2px;
  background: #c5c5c53d;
  width: 100%;
`

const ContainerTopOption = styled.div`
  > div:nth-child(1) {
    text-align: right;
  }

  > div:nth-child(2) {
    text-align: left;
    margin-top: 20px;
    margin-bottom: 40px;
  }

  > div:nth-child(1),
  > div:nth-child(2){
    > svg {
      max-width: 25px;
    }

    > img {
      max-width: 150px;
    }
  }
`

const ContainerLanguage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 10px;

  > div {
    display: flex;
    flex-direction: row;
    justify-contenr: center;
    align-items: center;
    margin: auto;

    > div img {
      width: 20px;
    }
  }

`
const customLanguaje = `
  margin: 0;
  height: fit-content;
  background: white;

  > select {
    background: white;
  }
`
const CustomButton = `
  transition: .2s;

  > div div svg{
    color: white;
  }

  :hover {
    background: #FEA500;
    border: 1px solid #FEA500;

    > div div svg {
      transform: rotate(90deg);
    }
  }
`
interface IOwnProps{
    children: any
}

const Layout: React.FunctionComponent<IOwnProps> = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [statusMenu, setStatusMenu] = React.useState(false)
  const [statusMenuMobile, setStatusMenuMobile] = React.useState(false)
  const handleMenu = () => setStatusMenuMobile(!statusMenuMobile)
  const [top, setTop] = React.useState(0)
  const location = useLocation()
  
  const onLoading = React.useCallback(() => {}, [])
  const onActive = React.useCallback(() => {}, [])
  window.onscroll = () => setTop(window.scrollY)

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useAdobeFonts({
    kitId: 'kal3ksx',
    onLoading,
    onActive,
  })

  const handleClickAccount = () => {
    window.location.href = 'mi-cuenta'
  }


  return (
    <LayoutContainer>
        <Navbar fixed={top > 300} onChangeMenu={handleMenu}/>
        <ContainerMenuMobile statusMenu={statusMenuMobile}>
          <ContainerList statusMenu={statusMenuMobile}>
            <ContainerTopOption>
              <div><CloseOutline onClick={handleMenu}/></div>
              <div><img src={logo} alt='logo chiclayo'/></div>
              <ContainerRoutes>
                {pathRoutes.map(route => {
                  const activeItem = route.path === location.pathname

                  return (
                    <ContainerTitle key={route.id}>
                      <TextTitle active={activeItem} to={route.path}>
                        {route.name}
                      </TextTitle>
                      <DividerTextTitle />
                    </ContainerTitle>
                  )
                })}
              </ContainerRoutes>
            </ContainerTopOption>
            <ContainerBottomOption>
              <div>
                <ContainerLanguage>
                  <div>
                    <div><img src={banderaPeru} alt='bandera de peru'/></div>
                    <div><SelectTC textHolder='Perú - Español' className={customLanguaje} background="white"/></div>
                  </div>
                </ContainerLanguage>
              </div>
              <div>
                <ButtonTC
                  text='Ver mi cuenta'
                  className={CustomButton}
                  buttonStyle={statusMenu ? 'secondary' : 'primary'}
                  icon={<ArrowIosForward />}
                  onClick={handleClickAccount}
                />
              </div>
            </ContainerBottomOption>
          </ContainerList>
        </ContainerMenuMobile>
        <>{children}</>
        <Footer />
    </LayoutContainer>
  )
}

export default Layout